require('./angular-messages');
module.exports = 'ngMessages';



// WEBPACK FOOTER //
// ./src/libs/angular-messages/index.js